import { createContext } from 'react';

import { featuresFlagReducerState, IFeatureFlagsReducer } from './reducer/featureFlagsReducer';

const FeatureFlagsContext = createContext<IFeatureFlagsReducer>(featuresFlagReducerState);

export { FeatureFlagsContext };
